<template>
    <div class="pagination" v-show="totalPages > 1">
        <ul>
            <li class="disabled"
                v-show="currentPage == 0"><span class="current prev">назад</span></li>
            <li v-show="currentPage > 0">
                <a href="" class="page-link prev"
                   @click.prevent="loadPrevPage">назад
                </a>
            </li>
            <li v-show="currentPage != 0"
                v-for="page in Array.from({length: currentPage}, (x,i) => i)">
                <a href="" @click.prevent="loadPage(page)" class="page-link">{{ page + 1 }}</a>
            </li>
            <li class="active"><span class="current">{{ currentPage + 1 }}</span></li>
            <li v-show="currentPage < (totalPages - 1)"
                v-for="page in Array.from({length: totalPages - currentPage - 1}, (x,i) => currentPage + i)">
                <a href="" @click.prevent="loadPage(page + 1)" class="page-link">{{ page + 2
                    }}</a>
            </li>
            <li class="disabled"
                v-show="currentPage == (totalPages - 1)"><span
                    class="current next">вперед</span></li>
            <li v-show="currentPage < (totalPages - 1)">
                <a href="" class="page-link next"
                   @click.prevent="loadNextPage">вперед
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'Pagination',

        props: ['currentPage', 'totalPages'],

        components: {},

        data() {
            return {}
        },

        computed: {},

        methods: {
            loadPage(page) {
                this.$emit('load-page', page);
            },

            loadNextPage() {
                this.loadPage(this.currentPage + 1);
            },

            loadPrevPage() {
                this.loadPage(this.currentPage - 1);
            }
        }
    }
</script>